module.exports = __webpack_public_path__ + "img/cy.dde11119.png";